import { androidDownloadUrl, iosDownloadUrl } from "../../shared/stores.ts";

/**
 * The standard App Store and Google Play badges, side by side (the gate's footer). Both are the
 * stores' own artwork, unaltered (public/badges/): Apple's black English SVG from its badge
 * service and Google's English PNG. Their guidelines forbid redrawing, recolouring or restyling
 * them, so they are the one place on the site that is not pixel art. Each links to the store
 * listing once it exists, and to TestFlight or the site's APK until then (shared/stores.ts).
 */
export function StoreBadges() {
  return (
    <div class="store-badges">
      <a class="store-badge" href={iosDownloadUrl()} target="_blank" rel="noopener" aria-label="Download on the App Store">
        <img class="store-badge-apple" src="/badges/app-store.svg" alt="Download on the App Store" width="120" height="40" />
      </a>
      <a class="store-badge" href={androidDownloadUrl()} target="_blank" rel="noopener" aria-label="Get it on Google Play">
        <img class="store-badge-google" src="/badges/google-play.png" alt="Get it on Google Play" width="646" height="250" />
      </a>
    </div>
  );
}
